const NonBreakingSpace = () => <span>&nbsp;</span>;

export default NonBreakingSpace;
